import React from 'react';
import { useTranslation } from 'react-i18next';

import { Wrapper } from '../../../components/Wrapper';
import { InterfaceWrapper } from '../../../components/InterfaceWrapper';
import { PlayerInterface } from './PlayerInterface';

import styled from 'styled-components';
import greenStrategy from '../../../assets/GreenStrategy.png';
import { StrategyHeader } from '../../../components/StrategyHeader';
import { colorConfig } from '../../../config/colors';

const Box = styled.div`
  gap: 64px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  h1,
  h2 {
    text-align: center;
  }
  img {
    margin-right: 70px;
  }
`;

export const Rules4 = InterfaceWrapper({
  Interface: PlayerInterface,
  Step: ({ data }) => {
    const { t } = useTranslation();

    return (
      <Wrapper>
        <Box>
          <img src={greenStrategy} alt="green" width="400px" />
          <div>
            <StrategyHeader>
              <h1
                dangerouslySetInnerHTML={{ __html: t('fishery.rules4', { strategyColor: colorConfig['green'].card }) }}
              />
            </StrategyHeader>
            <h2>{t('fishery.rules4a')}</h2>
          </div>
        </Box>
      </Wrapper>
    );
  },
});
